import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './NotFound.module.css';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className={styles.notFoundContainer}>
      <div className={styles.content}>
        <div className={styles.errorCode}>404</div>
        <h1 className={styles.title}>페이지를 찾을 수 없습니다</h1>
        <p className={styles.message}>
          요청하신 페이지가 존재하지 않거나 이동되었을 수 있습니다.
          <br />
          주소를 다시 확인해 주세요.
        </p>

        <div className={styles.buttonGroup}>
          <button onClick={handleGoBack} className={styles.backButton}>
            <svg
              className={styles.icon}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
            이전 페이지
          </button>

          <Link to="/" className={styles.homeButton}>
            <svg
              className={styles.icon}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
            홈으로
          </Link>
        </div>

        <div className={styles.quickLinks}>
          <h2 className={styles.quickLinksTitle}>자주 찾는 페이지</h2>
          <ul className={styles.linkList}>
            <li>
              <Link to="/company/about">안전원소개</Link>
            </li>
            <li>
              <Link to="/business/b1">안전교육</Link>
            </li>
            <li>
              <Link to="/check/c1">안전검사</Link>
            </li>
            <li>
              <Link to="/notice">공지사항</Link>
            </li>
            <li>
              <Link to="/cs/cs1">고객지원</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.illustration}>
        <svg
          viewBox="0 0 200 200"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.illustrationSvg}
        >
          <circle cx="100" cy="100" r="80" fill="#F0F4F8" />
          <circle cx="70" cy="80" r="8" fill="#015FBC" />
          <circle cx="130" cy="80" r="8" fill="#015FBC" />
          <path
            d="M 60 120 Q 100 140 140 120"
            stroke="#015FBC"
            strokeWidth="4"
            fill="none"
            strokeLinecap="round"
          />
        </svg>
      </div>
    </div>
  );
};

export default NotFound;
